import { Link } from 'react-router-dom';
import { topics } from '@/mocks/site';
import { getArticlesByTopic } from '@/mocks/articles';
import SectionHeading from '@/components/base/SectionHeading';

const TopicStrip = () => (
  <section className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16" aria-labelledby="topic-heading">
    <SectionHeading
      eyebrow="按主题追更"
      title="六大爆料方向"
      desc="每条爆料都归入固定栏目，方便你只订阅真正关心的内容方向。"
      action={
        <Link
          to="/topics"
          className="inline-flex whitespace-nowrap items-center gap-1 text-sm text-primary-600 hover:text-primary-700"
        >
          查看全部爆料
          <i className="ri-arrow-right-line text-base"></i>
        </Link>
      }
    />

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {topics.map((topic) => {
        const count = getArticlesByTopic(topic.slug).length;
        return (
          <Link
            key={topic.slug}
            to={`/topic/${topic.slug}`}
            className="group flex items-start gap-4 rounded-lg border border-background-200/70 bg-background-100/50 p-5 transition-colors hover:border-accent-300 hover:bg-accent-50"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
              <i className={`${topic.icon} text-2xl`}></i>
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center justify-between gap-2">
                <span className="font-heading text-base font-bold text-foreground-950">
                  {topic.name}
                </span>
                <span className="shrink-0 rounded-full bg-background-200/70 px-2 py-0.5 text-[11px] text-foreground-600">
                  {count} 篇
                </span>
              </span>
              <span className="mt-2 block text-sm leading-relaxed text-foreground-600">
                {topic.desc}
              </span>
            </span>
          </Link>
        );
      })}
    </div>
  </section>
);

export default TopicStrip;